export default __webpack_public_path__ + "static/media/XamBW928.d2a48df2.jpg";